const FETCH_MY_RESTRICTIONS = 'restrictionDetail/FETCH_MY_RESTRICTIONS';

const FETCH_USER_RESTRICTION = 'restrictionDetail/FETCH_USER_RESTRICTION';

const RESET = 'restrictionDetail/RESET';

export default {
  FETCH_MY_RESTRICTIONS,
  FETCH_USER_RESTRICTION,
  RESET,
};



// WEBPACK FOOTER //
// ./src/app/redux/front/restrictionDetail/types.js